export const MAX_FILE_MB = 100

const MAX_FILE_BYTES = MAX_FILE_MB * 1024 * 1024

export function validateFileSize(file: File): boolean {
  return file.size <= MAX_FILE_BYTES
}

export function mergedFilename(originalNames: string[]): string {
  if (originalNames.length === 0) return 'merged.pdf'
  if (originalNames.length === 1) {
    const name = originalNames[0]!
    const dot = name.lastIndexOf('.')
    const base = dot !== -1 ? name.slice(0, dot) : name
    return `${base}-merged.pdf`
  }
  return 'merged.pdf'
}

export async function mergePdfs(files: File[]): Promise<{ blob: Blob; totalPages: number }> {
  const { PDFDocument } = await import('pdf-lib')

  const mergedPdf = await PDFDocument.create()
  let totalPages = 0

  for (const file of files) {
    const bytes = await file.arrayBuffer()
    const pdfDoc = await PDFDocument.load(bytes)
    const pageIndices = pdfDoc.getPageIndices()
    totalPages += pageIndices.length
    const copiedPages = await mergedPdf.copyPages(pdfDoc, pageIndices)
    for (const page of copiedPages) {
      mergedPdf.addPage(page)
    }
  }

  const out = await mergedPdf.save()
  return { blob: new Blob([out], { type: 'application/pdf' }), totalPages }
}
